import { render, staticRenderFns } from "./markTag.vue?vue&type=template&id=24dc4c68&scoped=true&"
import script from "./markTag.vue?vue&type=script&lang=js&"
export * from "./markTag.vue?vue&type=script&lang=js&"
import style0 from "./markTag.vue?vue&type=style&index=0&id=24dc4c68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dc4c68",
  null
  
)

export default component.exports